
import { Component, Vue, Watch } from 'vue-property-decorator';

import CPLoader from '@/components/globals/CPLoader.vue';
import CPFetchingOverlay from '@/components/globals/CPFetchingOverlay.vue';
import CPRadioGroup from '@/components/open-account/input/CPRadioGroup.vue';

@Component({
  components: {
    CPFetchingOverlay,
    CPLoader,
    CPRadioGroup,
  },
})
export default class CPAlertsEdit extends Vue {

  public gainRate: number | null = null;
  public fallRate: number | null = null;

  public alertGainAction: number | null = null;
  public alertFallAction: number | null = null;
  public AutoResetGainFallValue: number | null = null;

  public loading: boolean = false;

  public get editAlert() {
    return this.$store.state.alerts.editAlert;
  }
  public get fetching() {
    return this.$store.state.alerts.fetching;
  }

  public close() {
    this.$store.commit('setEditAlert', null);
  }

  public async updateAlert() {
    this.loading = true;

    const alertGainAction = () => {
      switch (this.alertGainAction) {
        case 1:
          return 'AutoEmail';
        case 3:
          return 'AutoReset';
        case 4:
          return 'No Alert';
        default:
          return 'No Alert';
      }
    };
    const alertFallAction = () => {
      switch (this.alertFallAction) {
        case 1:
          return 'AutoEmail';
        case 3:
          return 'AutoReset';
        case 4:
          return 'No Alert';
        default:
          return 'No Alert';
      }
    };

    const updatedAlert: any = {
      GainRate: this.gainRate,
      FallRate: this.fallRate,
      AutoResetGainFallValue: this.AutoResetGainFallValue,
      GainSelection: alertGainAction(),
      FallSelection: alertFallAction(),
      TradeId: this.editAlert.TradeBuyId,
    };

    await this.$store.dispatch('updateAlert', updatedAlert);

    this.loading = false;
  }

  @Watch('editAlert')
  public updateVals() {
    this.gainRate = this.editAlert.GainRate;
    this.fallRate = this.editAlert.FallRate;

    if (this.editAlert.IsFallAutoEmail) {
      this.alertFallAction = 1;
    } else if (this.editAlert.IsFallAutoSell) {
      this.alertFallAction = 2;
    } else if (this.editAlert.IsAutoReset) {
      this.alertFallAction = 3;
    }

    if (this.editAlert.IsGainAutoEmail) {
      this.alertGainAction = 1;
    } else if (this.editAlert.IsGainAutoSell) {
      this.alertGainAction = 2;
    } else if (this.editAlert.IsGainAutoReset) {
      this.alertGainAction = 3;
    }
  }

  public mounted() {
    this.updateVals();
  }
}
